import { INITIAL_VALUES } from '../actionTypes';
import { actions } from '../reducer';

export default (values) => actions[INITIAL_VALUES](values);
